import template from './modal.html';
import vex from 'vex-js';
import 'vex-js/dist/css/vex.css';
import 'vex-js/dist/css/vex-theme-plain.css';
vex.defaultOptions.className = 'vex-theme-plain';

/**
 * Componente que representa a una ventana modal.
 */
export let ModalComponent = {
  templateUrl: template,
  selector: 'modal',
  transclude: true,
  bindings: {
    // objeto en el cual se cargará los métodos open y close del modal
    target: '=',

    // Opcional. clase css para el cuerpo del modal
    contentClassName: '@',

    // Opcional. scope de compilación. Por defecto es $parent
    targetScope: '=?',

    // Opcional. permite especificar el ID del elemento que representa el template
    // a utilizar como cuerpo del modal.
    templateId: '@'
  },
  controller: ModalCtrl,
  controllerAs: 'vm'
};

ModalCtrl.$inject = ['$element', '$compile', '$scope'];

function ModalCtrl($element, $compile, $scope) {

  this.$postLink = () => {
    let vm = this;
    this.target = {
      open() {
        let html;

        if (vm.templateId) {
          html = $(`#${vm.templateId}`).html();
        } else {
          html = $element.children().first().detach().html();
        }
        vm.vexInstance = vex.open({
          unsafeContent: $compile(html)(vm.targetScope || $scope.$parent)[0],
          contentClassName: vm.contentClassName || ''
        });
      },

      close() {
        vm.vexInstance.close();
      }
    };
  };

  this.$onDestroy = () => {
    if (this.vexInstance) {
      vex.close(this.vexInstance);
    }
  };
}


// WEBPACK FOOTER //
// ./src/core/components/modal/modal.component.js